import { render } from "./RouterRender.vue?vue&type=template&id=b090a46a&scoped=true"
import script from "./RouterRender.vue?vue&type=script&lang=js"
export * from "./RouterRender.vue?vue&type=script&lang=js"

import "./RouterRender.vue?vue&type=style&index=0&id=b090a46a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b090a46a"]])

export default __exports__